import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const SHOPIFY_SALES_REFERRER_SUCCESS = 'SHOPIFY_SALES_REFERRER_SUCCESS';
export const SHOPIFY_SALES_REFERRER_LOADING = 'SHOPIFY_SALES_REFERRER_LOADING';

const { ShopifySalesByReferrer: { getShopifySalesByReferrer } } = apiUrls;


export const getShopifySalesByReffererDetails = ({
  fromYear, toYear, fromMonth, toMonth
}) => async (dispatch) => {
  try {
    const { url } = getShopifySalesByReferrer
    const requestData = {
      ...getShopifySalesByReferrer,
      url,
      data: {
          fromYear,
          fromMonth,
          toYear,          
          toMonth
          }  
  };
    const data = await REQUEST(requestData);
    dispatch({
      type: SHOPIFY_SALES_REFERRER_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: SHOPIFY_SALES_REFERRER_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: SHOPIFY_SALES_REFERRER_LOADING,
    isLoading
  })
}
